function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Date");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.539946057
}, React.createElement("g", {
  id: "3.2-reporting-opt-2-copy",
  transform: "translate(-149.000000, -286.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-18",
  transform: "translate(40.000000, 255.000000)"
}, React.createElement("g", {
  id: "Group-17"
}, React.createElement("g", {
  id: "Group-7",
  transform: "translate(0.000000, 19.000000)"
}, React.createElement("g", {
  id: "noun_calender_160872",
  transform: "translate(109.000000, 12.000000)"
}, React.createElement("path", {
  d: "M6,3.67074527 C6,4.2269188 5.55555556,4.67185762 5,4.67185762 C4.44444444,4.67185762 4,4.2269188 4,3.67074527 L4,1.00111235 C4,0.444938821 4.44444444,0 5,0 C5.55555556,0 6,0.444938821 6,1.00111235 L6,3.67074527 Z M15.7777778,1.00111235 C15.7777778,0.444938821 15.3333333,0 14.7777778,0 C14.2222222,0 13.7777778,0.444938821 13.7777778,1.00111235 L13.7777778,3.67074527 C13.7777778,4.2269188 14.2222222,4.67185762 14.7777778,4.67185762 C15.3333333,4.67185762 15.7777778,4.2269188 15.7777778,3.67074527 L15.7777778,1.00111235 Z M20,3.53726363 L20,18.9098999 C20,19.5105673 19.5111111,20 18.8888889,20 L1.11111111,20 C0.488888889,20 0,19.5105673 0,18.9098999 L0,3.53726363 C0,2.93659622 0.488888889,2.44716352 1.11111111,2.44716352 L3.33333333,2.44716352 L3.33333333,3.67074527 C3.33333333,4.62736374 4.04444444,5.38375973 5,5.38375973 C5.95555556,5.38375973 6.66666667,4.6051168 6.66666667,3.67074527 L6.66666667,2.44716352 L13.1111111,2.44716352 L13.1111111,3.67074527 C13.1111111,4.62736374 13.8222222,5.38375973 14.7777778,5.38375973 C15.7333333,5.38375973 16.4444444,4.6051168 16.4444444,3.67074527 L16.4444444,2.44716352 L18.8666667,2.44716352 C19.4666667,2.44716352 20,2.93659622 20,3.53726363 Z M18.2222222,7.54171301 C18.2222222,7.3192436 18.0222222,7.11902113 17.7777778,7.11902113 L2.22222222,7.11902113 C1.97777778,7.11902113 1.77777778,7.29699666 1.77777778,7.54171301 L1.77777778,17.8197998 C1.77777778,18.0422692 1.97777778,18.2424917 2.22222222,18.2424917 L17.7777778,18.2424917 C18.0222222,18.2424917 18.2222222,18.0645161 18.2222222,17.8197998 L18.2222222,7.54171301 Z",
  id: "Shape"
})))))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.2881da68.svg";
export { ForwardRef as ReactComponent };